import { useState, useCallback, useEffect } from 'react';
import { SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { user } from 'services';
import { path } from 'router/sections';
import { prepareFormData } from 'libs/common';
import { addClient, updateClient } from 'services/client-service';
import { NaturalPersonForm } from './forms/natural-person';
import { LegalPersonForm } from './forms/legal-person';
import { SoleProprietorForm } from './forms/sole-proprietor';
import { LoginInfo, UpdateMessageBox, Content, Title } from './personal-data.styled';

export const PersonalData = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { client, refresh } = props;
  const clientId = client?.id;
  const login = client?.data?.lk_login;
  const clientType = client?.type;
  const isAdd = !clientId;
  const [updateMessage, setUpdateMessage] = useState(false);
  const [addMessage, setAddMessage] = useState(false);

  useEffect(() => {
    return () => {
      setUpdateMessage(false);
      setAddMessage(false);
    };
  }, []);

  /**
   * change client
   */
  const submit = useCallback(
    async (values) => {
      const rightUpdate = user.haveRight('clients.update');
      if (!rightUpdate) {
        return Promise.resolve();
      }

      if (isAdd) {
        const data = { ...client, ...values };

        try {
          const client = await addClient(data);
          showAddMessage();
          history.push(`${path('client')}?id=${client.id}`);
        } catch (error) {
          const submissionErrors = {};
          if (Array.isArray(error)) {
            error.forEach((element) => {
              submissionErrors[element.field] = element.type;
            });
          } else {
            submissionErrors['_error'] = error;
          }
          throw new SubmissionError(submissionErrors);
        }
      } else {
        const data = {
          ...values,
        };

        try {
          await updateClient(data);
          showUpdateMessage();
          refresh();
        } catch (error) {
          const submissionErrors = {};
          if (Array.isArray(error)) {
            error.forEach((element) => {
              submissionErrors[element.field] = element.type;
            });
          } else {
            submissionErrors['_error'] = error;
          }
          throw new SubmissionError(submissionErrors);
        }
      }
    },
    [clientId]
  );

  /**
   * show update message
   */
  const showUpdateMessage = () => {
    setUpdateMessage(true);
    setTimeout(() => {
      setUpdateMessage(false);
    }, 3000);
  };

  /**
   * show add message
   */
  const showAddMessage = () => {
    setAddMessage(true);
    setTimeout(() => {
      setAddMessage(false);
    }, 3000);
  };

  /**
   * get form component
   */
  const getForm = useCallback(() => {
    switch (clientType) {
      case 'natural_person':
        return NaturalPersonForm;
      case 'legal_person':
        return LegalPersonForm;
      case 'sole_proprietor':
        return SoleProprietorForm;
      default:
        return null;
    }
  }, [clientType]);

  const Form = getForm();

  /**
   * prepare client data for form
   */
  const prepareClientData = () => {
    const out = { ...client };
    let { lk_unlimited, lk_login } = out.data ? out.data : { lk_unlimited: '', lk_login: '' };
    out.lk_unlimited = lk_unlimited;
    out.lk_login = lk_login;
    return prepareFormData(out);
  };

  const data = prepareClientData(client);

  return (
    <Content>
      <Title>{t('form.Персональные данные')}</Title>
      {login && (
        <LoginInfo>
          <b>{t('form.Логин ЛК')}</b>
          <i>{login}</i>
        </LoginInfo>
      )}

      {!!Form && <Form onSubmit={submit} initialValues={data} />}

      {updateMessage && <UpdateMessageBox>{t('messages.Изменения сохранены')}</UpdateMessageBox>}
      {addMessage && <UpdateMessageBox>{t('messages.Клиент успешно создан')}</UpdateMessageBox>}
    </Content>
  );
};
